module.exports = __webpack_public_path__ + "img/06.e37084b4.png";